import React from 'react'
import { ADMIN_PERMISSION_ACTIONS, ADMIN_PERMISSION_MENUS, normalizePermissions, permissionPreset } from '../data/adminPermissions'

export default function AdminPermissionMatrix({ role, value, onChange }) {
  const permissions = normalizePermissions(role, value)

  const setPermission = (menuKey, action, checked) => {
    const next = normalizePermissions(role, permissions)
    next[menuKey] = { ...next[menuKey], [action]: checked }
    if (action === 'view' && !checked) {
      next[menuKey].export = false
      next[menuKey].edit = false
      next[menuKey].approve = false
    } else if (action !== 'view' && checked) {
      next[menuKey].view = true
    }
    onChange(next)
  }

  const applyPreset = () => onChange(permissionPreset(role))

  return <div className="admin-permission-matrix-wrap">
    <div className="admin-permission-matrix-head">
      <div><strong>메뉴별 세부 권한</strong><p>조회 권한이 없으면 해당 메뉴 접근 자체를 막고, 다운로드·등록/수정·승인/처리를 별도로 제어합니다.</p></div>
      <button type="button" className="button soft" onClick={applyPreset}>역할 기본값 다시 적용</button>
    </div>
    <div className="table-scroll"><table className="data-table compact admin-permission-matrix"><thead><tr><th>메뉴</th>{ADMIN_PERMISSION_ACTIONS.map((action) => <th key={action.key}>{action.label}</th>)}</tr></thead><tbody>
      {ADMIN_PERMISSION_MENUS.map((menu) => <tr key={menu.key}><td><strong>{menu.label}</strong></td>{ADMIN_PERMISSION_ACTIONS.map((action) => <td key={action.key}><label className="admin-permission-check"><input type="checkbox" checked={Boolean(permissions[menu.key]?.[action.key])} onChange={(event) => setPermission(menu.key, action.key, event.target.checked)} /><span>{permissions[menu.key]?.[action.key] ? '허용' : '차단'}</span></label></td>)}</tr>)}
    </tbody></table></div>
  </div>
}
